module.exports = __webpack_public_path__ + "static/img/jigou-2-bottom.bc026a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou-2-bottom.png
// module id = fhjx
// module chunks = 2